import { createFileRoute, Link } from '@tanstack/react-router';
import { useThreads } from '@/data/messaging';
import { Empty } from '@/components/ui/Empty';

export const Route = createFileRoute('/admin/messages/')({
  component: AdminMessagesIndex,
});

function AdminMessagesIndex() {
  const threads = useThreads();

  return (
    <div className="space-y-8">
      <header>
        <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
          Inbox
        </p>
        <h1 className="mt-2">Messages</h1>
        <p className="mt-1 text-[var(--color-ink-muted)]">
          All parent conversations, most recent first.
        </p>
      </header>

      {threads.isLoading && <p aria-live="polite">Loading…</p>}

      {threads.data?.length === 0 && (
        <Empty
          title="No messages yet"
          description="When a family sends a message, the thread appears here."
        />
      )}

      {threads.data && threads.data.length > 0 && (
        <ul className="grid gap-2">
          {threads.data.map((t) => (
            <li key={t.id} className="surface-elevated">
              <Link
                to="/admin/messages/$threadId"
                params={{ threadId: t.id }}
                className="block p-4 hover:bg-[var(--color-surface-sunken)] focus-visible:outline-none"
              >
                <div className="flex items-baseline justify-between gap-3">
                  <h2 className="font-medium text-[var(--text-base)]">{t.subject}</h2>
                  <p className="text-[var(--color-ink-subtle)] text-[var(--text-xs)] tabular-nums">
                    {new Date(t.last_message_at).toLocaleDateString()}
                  </p>
                </div>
                <p className="mt-1 text-[var(--color-ink-muted)] text-[var(--text-xs)]">
                  Family <span className="font-mono">{t.family_id.slice(0, 8)}…</span>
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
